export default function generateBackground(background_color) {
	const bgColors = background_color.colors.map(({ color, opacity }) => `rgb(${color} / ${opacity})`).join(",")
	return { background: background_color.colors.length > 1 ? `linear-gradient(${bgColors})` : bgColors }
}
